import Objectif from './Objectif'

const Page = ({ toast }) => {
    return <Objectif toast={toast} />
}

export default Page
